<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">
            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">Dados do Boleto</h1>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div>
                  <button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" ref="btedit" @click="voltar">Voltar</button>
                  <button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" ref="btedit" @click="editar">Editar</button>
                  <button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" ref="btnovo" @click="novo">Novo</button>
                </div>
                <div class="col-sm-9 m-t-xl" style="width:100%;display: flex;flex-direction: row; justify-content: center;">                  


                  <!-- DADOS DO BOLETO -->


                  <table style="border-collapse: separate;border-spacing: 10px 10px;" v-if="isLoaded">
                    <tr>
                      <td style="text-align: right;">Numero do Titulo:</td>
                      <td >
                        <input class="form-control form-control-sm w-auto" maxlength="11" disabled style="text-align: left;" type="text" name="NossoNumero" id="NossoNumero" v-model='900000000000+boleto.sequencialNossoNumero'>
                      </td>
                      <td style="text-align: right;">Data Vencimento:</td>
                      <td >
                        <input class="form-control form-control-sm w-auto" placeholder="DD/MM/YYYY" maxlength="11" disabled style="text-align: left;" 
                        type="text" name="DataVencimento" ref="DataVencimento" v-model="boleto.dataVencimento" v-mask="'##/##/####'">
                      </td>
                      <td style="text-align: right;">Status:</td>
                      <select disabled class="form-control form-control-sm" ref="Status" v-model='boleto.status'>
                        <option value='0'>Aguardando registro</option>
                        <option value='1'>Enviado para registro</option>
                        <option value='2'>Registrado</option>
                      </select>
                    </tr>
                    <tr>
                      <td style="text-align: right;">Sacado:</td>
                      <td >
                        <input class="form-control form-control-sm w-auto" disabled style="width:300px; text-align: left;" type="text" name="Sacado" ref="Sacado" v-model='boleto.nomePagador'>
                      </td>
                      <td style="text-align: right;">Tipo Documento:</td>
                      <td >
                        <select disabled class="form-control form-control-sm" ref="tipoDocumento" v-model='boleto.tipoPagador'>
                          <option value='0' disabled>Selecione...</option>
                          <option value='1'>CPF</option>
                          <option value='2'>CNPJ</option>
                        </select>
                      </td>
                      <td style="text-align: right;">Número Documento:</td>  
                      <td >
                        <input v-if="doccpf" class="form-control form-control-sm w-auto" disabled style="width:200px; text-align: left;" type="text" name="Documento" ref="Documento" v-model='boleto.documentoPagador'
                        v-mask="'###.###.###-##'">
                        <input v-if="!doccpf" class="form-control form-control-sm w-auto" disabled style="width:200px; text-align: left;" type="text" name="Documento" ref="Documento" v-model='boleto.documentoPagador'
                        v-mask="'###.###.###/####-##'">
                      </td>                      
                    </tr>
                    <tr>
                      <td style="text-align: right;">Endereço:</td>
                      <td >
                        <input class="form-control form-control-sm w-auto" disabled style="width:400px; text-align: left;" type="text" name="Endereco" ref="Endereco" v-model='boleto.enderecoPagador'>
                      </td>
                      <td style="text-align: right;">CEP:</td>
                      <td >
                        <input class="form-control form-control-sm w-auto" disabled style="width:100px; text-align: left;" type="text" name="Cep" ref="Cep" v-model='boleto.cepPagador'
                        v-mask="'#####-###'">
                      </td>
                      <td style="text-align: right;">Acesso do arrematante:</td>
                      <td >
                        <select disabled class="form-control form-control-sm" ref="StatusBoleto" v-model='boleto.statusBoleto'>
                          <option value='3' disabled>Selecione...</option>
                          <option value='0'>Restrito</option>
                          <option value='1'>Liberado</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right;">Valor Documento:</td>
                      <td >
                        <input class="form-control form-control-sm w-auto" disabled style="width:200px; text-align: left;" type="text" name="valor" ref="Valor" v-model='"R$ " + boleto.valor'>
                      </td>
                    </tr>                                                                                     
                  </table>                                                                        
                </div>
              </div>
              <div class="wrapper clearfix">
                <button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" ref="btcancelar" disabled @click="cancelar">Cancelar</button>   
                <button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" ref="btsalvar" disabled>Salvar</button>                
              </div>                
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

  import service from '../../../../domain/cobranca/services'
  import { VueMaskDirective as mask } from 'v-mask'

  export default {
    name: 'Boletos',
    directives: {mask},
    data () {
      return {
        boletopersist: {},
        boleto: null,
        last: null,
        isLoaded: false,
        doccpf: false
      }
    },
    created () {
      this.load()
    },
    mounted () {
    },
    watch: {
      boleto () {
        this.boleto.dataVencimento = this.moment(this.boleto.dataVencimento.data).format('DD/MM/YYYY')
      },
      'boleto.tipoPagador' (newVal) {
        console.log(newVal)
        if (newVal === '2') {
          this.doccpf = false
        } else {
          this.doccpf = true
        }
      }
    },
    methods: {
      load () {
        this.isLoaded = false
        this.$loaderOverlay.open().message('Aguarde enquanto carregamos o boleto')
        service.find(this.$route.params.id).then((response) => {
          this.boleto = response.data[0]
          this.last = response.data.last
          this.$nextTick(() => {
            if (this.boleto.tipoPagador === 1) {
              this.doccpf = true
            } else {
              this.doccpf = false
            }
            this.$loaderOverlay.hide()
            this.isLoaded = true
          })
        }).catch((error) => {
          this.isLoaded = true
          this.$loaderOverlay.hide()
          console.log(error)
        })
      },
      formatedoc (num) {
        let newnum = ''
        if (num.lenght === 14) {
          newnum = num.substring(0, 2) + '.' + num.substring(2, 3) + '.' + num.substring(5, 3) + '/' + num.substring(8, 4) +
          '-' + num.substring(13, 2)
        } else if (num.lenght === 11) {
          newnum = num.substring(0, 3) + '.' + num.substring(3, 3) + '.' + num.substring(9, 3) +
          '-' + num.substring(9, 2)
        }
        return newnum
      },
      editar () {
        Object.assign(this.boletopersist, this.boleto)
        if (this.boleto.status === 0) {
          Object.entries(this.$refs).forEach(([key, propriedade]) => {
            if (key === 'Status') {
              propriedade.disabled = true
            } else if (key === 'btnovo' || key === 'btedit') {
              propriedade.disabled = true
            } else {
              propriedade.disabled = false
            }
          })
        } else {
          window.alert('O boleto ja foi enviado para registro ou ja foi registrado!')
        }
      },
      novo () {
        console.log(this.boleto)
        Object.assign(this.boletopersist, this.boleto)
        Object.entries(this.$refs).forEach(([key, propriedade]) => {
          if (key === 'Status') {
            propriedade.disabled = true
          } else if (key === 'btnovo' || key === 'btedit') {
            propriedade.disabled = true
          } else {
            propriedade.disabled = false
          }
        })
        console.log(this.boletopersist)
        this.boleto.sequencialNossoNumero = 1 + this.last
        this.boleto.dataVencimento = null
        this.boleto.status = 0
        this.boleto.statusBoleto = 3
        this.boleto.tipoPagador = 0
        this.boleto.nomePagador = ''
        this.boleto.enderecoPagador = ''
        this.boleto.valor = ''
        this.boleto.cepPagador = ''
        this.boleto.documentoPagador = ''
      },
      voltar () {
        this.$router.back()
      },
      cancelar () {
        Object.entries(this.$refs).forEach(([key, propriedade]) => {
          if (key === 'btnovo' || key === 'btedit') {
            propriedade.disabled = false
          } else {
            propriedade.disabled = true
          }
        })
        this.boleto.sequencialNossoNumero = this.boletopersist.sequencialNossoNumero
        this.boleto.dataVencimento = this.boletopersist.dataVencimento
        this.boleto.status = this.boletopersist.status
        this.boleto.statusBoleto = this.boletopersist.statusBoleto
        this.boleto.nomePagador = this.boletopersist.nomePagador
        this.boleto.enderecoPagador = this.boletopersist.enderecoPagador
        this.boleto.valor = this.boletopersist.valor
        this.boleto.cepPagador = this.boletopersist.cepPagador
        this.boleto.tipoPagador = this.boletopersist.tipoPagador + ''
        this.boleto.documentoPagador = this.boletopersist.documentoPagador
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VisualizarBoleto.vue?7f91e584